/**
 * O que a tela ja sabe que o servidor recusaria na ativacao do rascunho (R5-B32).
 *
 * O servidor recusa ativar o grupo debaixo de ramo em rascunho e a modalidade debaixo
 * de ramo ou grupo em rascunho, ou sem taxa base quando a configuracao ativa usa taxa
 * por modalidade (`uses_modality_rate`). Sem taxa por modalidade, a taxa vem do
 * tomador ou da analise, e a taxa base nao e exigida (ADR 0091). A tela desliga o
 * "Ativar" com o motivo, em vez de deixar a primeira tentativa responder 409. A
 * existencia da configuracao aprovada (Detalhes da modalidade) so o servidor confere.
 */

/** Por que o grupo ainda nao pode ser ativado, ou null. */
export function bloqueioDoGrupo(ramo: { status: string }): string | null {
  return ramo.status === 'rascunho'
    ? 'Ative o ramo antes: o grupo nao sai do rascunho debaixo de ramo em rascunho.'
    : null;
}

/** Por que a modalidade ainda nao pode ser ativada, ou null. */
export function bloqueioDaModalidade(
  modalidade: { base_rate_bps: number; uses_modality_rate?: boolean | undefined },
  ramo: { status: string },
  grupo: { status: string } | undefined,
): string | null {
  if (ramo.status === 'rascunho') {
    return 'Ative o ramo antes: a modalidade nao sai do rascunho debaixo de ramo em rascunho.';
  }
  if (grupo?.status === 'rascunho') {
    return 'Ative o grupo antes: a modalidade nao sai do rascunho debaixo de grupo em rascunho.';
  }
  if (modalidade.base_rate_bps <= 0 && modalidade.uses_modality_rate === true) {
    return 'Informe a taxa base antes de ativar: a configuracao usa taxa por modalidade, e a modalidade ativa entra na cotacao.';
  }
  return null;
}
